import Rails from '@rails/ujs'
import { Application } from 'stimulus';
import { registerControllers } from 'stimulus-vite-helpers'
import Inputmask from 'inputmask/dist/inputmask/inputmask.numeric.extensions';
import 'actiontext';
import '../analytics';
import Chartkick from 'chartkick'
import Highcharts from 'highcharts'

import DataModule from 'highcharts/modules/data';
import ExportingModule from 'highcharts/modules/exporting';
import OfflineExportingModule from 'highcharts/modules/offline-exporting';
import MapModule from 'highcharts/modules/map';

DataModule(Highcharts)
ExportingModule(Highcharts)
OfflineExportingModule(Highcharts)
MapModule(Highcharts)

Chartkick.use(Highcharts)
Rails.start()

const application = Application.start();
const controllers = import.meta.glob('../**/*_controller.js', { eager: true });
registerControllers(application, controllers);

window.Inputmask = Inputmask;
